module.exports = __webpack_public_path__ + "img/logo.3cc479c7.png";